import { Card, Checkbox, Space, Flex } from 'antd'
import { Filter } from 'lucide-react'
import { SectionVisibilityControls } from '../../../features/reportSections'
import { LabelFilterUI } from '../../../features/labelFilter'
import { useFeatureAccessContext } from '../../../context/featureAccess'
import type { SectionKey } from '../../../features/reportSections'
import type { ProjectLabel } from '@bandos/shared'
import type { SetURLSearchParams } from 'react-router-dom'

interface PresentationOptionsProps {
  nodeFilterId: string | null
  setSearchParams: SetURLSearchParams
  isVisible: (key: SectionKey) => boolean
  toggleSection: (key: SectionKey) => void
  showStakeholderRatings: boolean
  onShowStakeholderRatingsChange: (checked: boolean) => void
  projectLabels: ProjectLabel[]
  selectedFilterLabels: string[]
  onFilterLabelsChange: (labels: string[]) => void
}

export function PresentationOptions({
  nodeFilterId,
  setSearchParams,
  isVisible,
  toggleSection,
  showStakeholderRatings,
  onShowStakeholderRatingsChange,
  projectLabels,
  selectedFilterLabels,
  onFilterLabelsChange,
}: PresentationOptionsProps) {
  const { isFeatureEnabled } = useFeatureAccessContext()

  return (
    <Card
      size="small"
      style={{ marginBottom: '24px' }}
      className="no-print"
      title={
        <Space size="small">
          <Filter size={14} />
          <span>Presentation Options</span>
        </Space>
      }
    >
      <Flex vertical gap="middle">
        {nodeFilterId && (
          <Checkbox
            checked={true}
            onChange={(e) => {
              if (!e.target.checked) {
                setSearchParams(
                  (prev) => {
                    const newParams = new URLSearchParams(prev)
                    newParams.delete('nodeFilter')
                    return newParams
                  },
                  { replace: true }
                )
              }
            }}
          >
            Filtered by selected node
          </Checkbox>
        )}

        <SectionVisibilityControls isVisible={isVisible} toggleSection={toggleSection} />

        {isFeatureEnabled('simulated_stakeholders') && (
          <Checkbox
            checked={showStakeholderRatings}
            onChange={(e) => onShowStakeholderRatingsChange(e.target.checked)}
          >
            Include stakeholder feedback
          </Checkbox>
        )}

        {isFeatureEnabled('labels') && projectLabels.length > 0 && (
          <LabelFilterUI
            variant="card"
            selectedLabels={selectedFilterLabels}
            onLabelsChange={onFilterLabelsChange}
            availableLabels={projectLabels}
          />
        )}
      </Flex>
    </Card>
  )
}
